/** 녹화된 행동 출처의 조회 선택지다. none도 다른 값과 OR로 묶는다. */
export const ACTION_SOURCE_OPTIONS = [
  {
    value: "teleop",
    label: "원격 조작(teleop)",
    description: "사람이 원격 조작으로 낸 Action이 기록되어 있습니다.",
  },
  {
    value: "inference",
    label: "Policy Inference(inference)",
    description: "Policy가 스스로 낸 Action이 기록되어 있습니다.",
  },
  {
    value: "intervention",
    label: "사람 개입(intervention)",
    description: "Policy 실행 중 사람이 개입해 낸 Action이 기록되어 있습니다.",
  },
  {
    value: "script",
    label: "스크립트(script)",
    description: "미리 짠 스크립트가 낸 Action이 기록되어 있습니다.",
  },
  {
    value: "none",
    label: "없음(none)",
    description: "행동 출처 값이 없습니다. 채널이 없거나 아직 진단하지 않았을 수 있습니다.",
  },
] as const;

export function actionSourceText(value: string): string {
  return ACTION_SOURCE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}
